import { useMemo } from 'react'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import usePortalQuery from 'src/Libs/api/hooks/use-portal-query'
import { AccountLinkModel } from 'src/Libs/installation-rights-management/models'
import { AccountType } from 'src/Libs/installation-rights-management/types'
import { getAccountLinkList } from '../api'

type UseAccountLinkListReturnType = [AccountLinkModel[], boolean, () => void]

/**
 * Hook to get account links of an installation
 * @param installationId - Installation id
 * @param accountType - Optional account type filter
 */
export const useAccountLinkList = (installationId: number | string | undefined, accountType?: AccountType): UseAccountLinkListReturnType => {
  const authFetch = useAuthFetchWithResponse()

  const { data, isLoading, refetch } = usePortalQuery({
    queryKey: ['installations-account-links', installationId, accountType],
    queryFn: () => getAccountLinkList(`${installationId}`, authFetch, accountType),
    enabled: !!installationId,
  })

  const result = useMemo(() => {
    if (accountType) {
      return data?.filter(accountLink => accountLink.accountType === accountType) ?? []
    }
    return data ?? []
  }, [data, accountType])

  return [result, isLoading, refetch]
}
